const centsToDollars = (cents: number): string => {
    // Convert the numeric value to currency from cents (has 2 decimal places)
    const dollars = cents / 100;
    return dollars.toFixed(2);
};

export default centsToDollars;